import React from "react";
import Logo from "../Logo/Logo";

import "./Footer.sass";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row flex-column flex-md-row align-items-center align-items-md-end justify-content-between">
          <section className="col-auto order-2 order-md-1 footer__left">
            <Logo />
            <span className="copyright">
              Copyright ©2017-{currentYear} All rights reserved
            </span>
          </section>
          <section className="col-auto order-1 order-md-2 footer__links">
            <span>
              <a target="_blank" href="/?p=lp_tos">
                Terms and Conditions
              </a>
              |
              <a target="_blank" href="/?p=lp_privacy">
                Privacy Policy
              </a>
              |
              <a target="_blank" href="/?p=lpd_uninstall_r1">
                Uninstall Instructions
              </a>
            </span>
          </section>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
